var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.390625 6.33973C0.390625 6.12838 0.471325 5.91698 0.63236 5.75579L5.70488 0.683409C6.02755 0.360739 6.5507 0.360739 6.87324 0.683409C7.19578 1.00595 7.19578 1.529 6.87324 1.85169L2.38487 6.33973L6.87293 10.8279C7.19547 11.1505 7.19547 11.6736 6.87293 11.9961C6.55039 12.3189 6.02739 12.3189 5.70472 11.9961L0.632177 6.92382C0.471168 6.76255 0.390625 6.55115 0.390625 6.33973Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.1aa1d0aca8eb9538098e67e5b1774b5b.svg";
export { ForwardRef as ReactComponent };